import VcsDetailsPage from "../../shared/VcsShared/components/VcsDetailsPage";

const GitlabDetailsPage = VcsDetailsPage;

export default GitlabDetailsPage;
